<template>
	<div>
		<Cadastrar :showForm="showFormCadastro" :parent="this"/>

		<ed-table
			registerName="Desativar Nova Empresa"
			:onRegister="(this.validarPermissao(310) ? onRegister: null)"
			:onDelete="onDelete"
			:onSearch="getDesativado"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:pagination="pagination"
			:response="response"
		>
		</ed-table>
	</div>
</template>

<script>

	import EdTable from 'common/table'
	import Rest from 'common/rest'
	import Fct from 'common/fct'
	import Cadastrar from './cadastrar'

  	export default {
  		name:"periodicos-disparo",
  		components: {EdTable,Cadastrar},
  		mixins:[Rest],
  		data () {
		   	return {
				pagination:{},
				response:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						width:'60px',
						label: 'Cód',
		            },
		            {
		                key: 'empresa',
						sortable: true,
						label: 'Empresa',
					},
					{
		                key: 'funcionario',
						sortable: true,
						label: 'Funcionário',
					},
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
		            },
		   		],
		   		tableData:[],
				loadingTable:true,
				showFormCadastro:false,

			}
		},
		beforeDestroy(){
			this.tableData = [];
		},
		created(){
		},

		mounted: function() {
			this.getDesativado();
		},

		methods: {

			onRegister: function(){
				this.showFormCadastro = !this.showFormCadastro;
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

                    self.loadingEditAll = true;

                    this.post('/periodico/desativado/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingEditAll = false;

                        if(result.status == 200){

                            this.getDesativado();
                            this.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getDesativado: function(_search,_page,_pagination){

				this.loadingTable = true;
				this.response = {};

				this.get('periodico/desativado',{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					result = result[0];
					this.response = result;
					this.loadingTable = false;

		            if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		self = this,
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {
							
		             		var item = {
								'id': data[i].id,
								'empresa': data[i].empresa.nome,
								'funcionario': (data[i].funcionario ? data[i].funcionario.nome : '---'),
								'updated_at': this.toDate(data[i].updated_at),
		             			_data:data[i],
		             			options:{
									disable_delete:!this.validarPermissao(310),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		            	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		             }
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?7a98b5c0